module.exports = __webpack_public_path__ + "media/images/placeholder-steps-843a22b0.png";